import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { Reveal } from "../Reveal";
import { images } from "../../data/store";
import { products } from "../../data/products";
const banners = [{
  title: "Her pleasure, amplified.",
  text: "Formulas made for her desire, sensitivity and sensation.",
  cta: "Shop for her",
  to: "/shop?for=her",
  image: images.her,
  alt: "A woman in a black satin dress in red light",
  category: "her" as const
}, {
  title: "Power when it matters.",
  text: "Royal honey, Seven Sins and gels for stamina, energy and confidence.",
  cta: "Shop for him",
  to: "/shop?for=him",
  image: images.him,
  alt: "A man in an open black shirt in dramatic light",
  category: "him" as const
}];
export function NeedBanners() {
  return <section className="bg-night pb-20 lg:pb-28" data-id="element-265" data-mp="2mz8jtq9mihce">
      <div className="mx-auto grid max-w-7xl gap-4 px-6 md:grid-cols-2" data-id="element-266" data-mp="2r2dj7jyeq2wt">
        {banners.map((b, i) => {
        const thumbs = products.filter(p => p.category === b.category).slice(0, 3);
        return <Reveal key={b.title} delay={i * 0.08} data-id="element-267" data-mp="1h7lh57lsjval" data-mpi={i}>
              <Link to={b.to} className="group relative isolate flex aspect-[4/5] flex-col justify-end overflow-hidden rounded-[28px] p-8 lg:aspect-[5/6] lg:p-10" data-id="element-268" data-mp="1v6324xkbatot">
                <img src={b.image} alt={b.alt} className="absolute inset-0 -z-10 h-full w-full object-cover transition-transform duration-300 ease-brand group-hover:scale-[1.04]" data-id="element-269" data-mp="253zaxips1cjr" />
                <div className="absolute inset-x-0 bottom-0 -z-10 h-3/5 bg-night/60" aria-hidden="true" data-id="element-270" data-mp="2etipwdadcm9c" />

                <div className="absolute right-6 top-6 flex -space-x-3" data-id="element-271" data-mp="29vqzxotaba7s">
                  {thumbs.map((t, ti) => <img key={t.slug} src={t.images[0]} alt="" className="h-14 w-14 rounded-full border-2 border-night bg-white object-contain transition-transform duration-200 ease-brand group-hover:-translate-y-1" style={{
                transitionDelay: `${ti * 40}ms`
              }} data-id="element-272" data-mp="2nsdxntt2a4er" data-mpi={ti} />)}
                </div>

                <h2 className="max-w-xs font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl" data-id="element-273" data-mp="1u9w4cryjor3w">
                  {b.title}
                </h2>
                <p className="mt-4 max-w-sm text-white/80" data-id="element-274" data-mp="247tslfgemnwi">{b.text}</p>
                <span className="mt-7 inline-flex w-fit items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-night transition-colors group-hover:bg-brand" data-id="element-275" data-mp="245z7o154uvsf">
                  {b.cta}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-276" data-mp="2d6e5fzzaa3ct" />
                </span>
              </Link>
            </Reveal>;
      })}
      </div>
    </section>;
}